export const GET_AUDIT_LOG_TYPE_NAMES = "GET_AUDIT_LOG_TYPE_NAMES"
export const GET_AUDIT_LOG_ENTRIES = "GET_AUDIT_LOG_ENTRIES"


// WEBPACK FOOTER //
// ./src/actionTypes/auditLog.js